export default __webpack_public_path__ + "static/media/person_2@3x.07f5aa21.png";